import { Box, MenuItem, TextField } from "@mui/material"
import { HelpOutlined, KeyboardArrowDownOutlined } from "@mui-symbols-material/w300"
import { type FC } from "react"

import { type UnitOfMeasurement } from "@/graphql/codegen/graphql"

interface QuantityFieldUomProps {
  onInputChange: (args: { value: string; name: string }) => void
  filteredUoM: UnitOfMeasurement[]
  value: string
  disabled?: boolean
}

export const QuantityFieldUom: FC<QuantityFieldUomProps> = ({
  value,
  onInputChange,
  filteredUoM,
  disabled = false,
}: QuantityFieldUomProps) => {
  const filteredValue = filteredUoM.some(({ id }) => id === value) ? value : ""

  return (
    <Box className='flex items-center gap-1'>
      <HelpOutlined />
      <TextField
        select
        size='small'
        variant='standard'
        disabled={disabled}
        sx={{
          "& .MuiInput-root": {
            border: "none",
            "&:before, &:after": { display: "none" },
          },
          minWidth: "60px",
          "& .MuiSelect-select": {
            padding: "2px 4px",
          },
        }}
        slotProps={{
          select: {
            IconComponent: KeyboardArrowDownOutlined,
            MenuProps: {
              PaperProps: {
                style: { maxHeight: 48 * 4.5 + 8, width: 60 },
              },
            },
          },
        }}
        onChange={(e) => {
          onInputChange({ value: e.target.value, name: "uomId" })
        }}
        value={filteredValue}
      >
        {filteredUoM.map(({ id, name }) => (
          <MenuItem key={id} value={id}>
            {name}
          </MenuItem>
        ))}
      </TextField>
    </Box>
  )
}
